export enum PAGE_GROUPS {
  GROUP_GENERAL = 'GROUP_GENERAL',
  GROUP_SETTINGS = 'GROUP_SETTINGS',
}

// Collapsible menu item grouping several pages together inside a PAGE_GROUPS block.
export enum MENU_SUBGROUPS {
  REPORTS = 'REPORTS',
}

export const MENU_SUBGROUP_ICONS: Record<MENU_SUBGROUPS, string> = {
  [MENU_SUBGROUPS.REPORTS]: 'mdi-chart-box-multiple',
};

export const enum PAGE_NAMES {
  INDEX = 'INDEX',
  LOGIN = 'LOGIN',
  PUBLIC = 'PUBLIC',
  SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK',
  APPROVE_ABSENCE = 'APPROVE_ABSENCE',
  APP = 'APP',
  DASHBOARD = 'DASHBOARD',
  SITDOWN = 'SITDOWN',
  PROJECTS = 'PROJECTS',
  ABSENCES = 'ABSENCES',
  GAME = 'GAME',
  ACHIEVEMENTS = 'ACHIEVEMENTS',
  WORKLOGS = 'WORKLOGS',
  USERS = 'USERS',
  POSITIONS = 'POSITIONS',
  FEEDBACK_HEATMAP = 'FEEDBACK_HEATMAP',
  SITDOWN_TIMES = 'SITDOWN_TIMES',
  SETTINGS = 'SETTINGS',
  USER_GOALS = 'USER_GOALS',
  USER_1ON1S = 'USER_1ON1S',
  COLLABORATOR_NOTES = 'COLLABORATOR_NOTES',
  COLLABORATOR_HISTORY = 'COLLABORATOR_HISTORY',
  COLLEAGUES = 'COLLEAGUES',
  COLLEAGUES_DETAIL = 'COLLEAGUES_DETAIL',
  USER_SETTINGS = 'USER_SETTINGS',
  ABSENCES_APPROVING = 'ABSENCES_APPROVING',
  SUBSTITUTE_GROUPS = 'SUBSTITUTE_GROUPS',
  SECURITY_TF = 'SECURITY_TF',
  DOCUMENTS = 'DOCUMENTS',
  DOCUMENTS_CREATE = 'DOCUMENTS_CREATE',
  DEV_METRICS = 'DEV_METRICS',
  PCLDX_METRICS = 'PCLDX_METRICS',
  METABASE_METRICS = 'METABASE_METRICS',
  PM_METRICS = 'PM_METRICS',
  WORKING_TIME_RECORDS = 'WORKING_TIME_RECORDS',
  WORKING_TIME_RECORDS_ADMINISTRATION = 'WORKING_TIME_RECORDS_ADMINISTRATION',
  DOCUMENTATION = 'DOCUMENTATION',
}
